import axios from "axios";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// Dynamically import components
const UserProfile = lazy(() => import("../pages/Templates/PersonalProfile"));
const AppointmentProfile = lazy(() =>
  import("../pages/Templates/AppointmentProfile")
);
const RestaurantProfile = lazy(() =>
  import("../pages/Templates/RestaurantProfile")
);
const ShopProfile = lazy(() => import("../pages/Templates/ShopProfile"));
const RealEstateProfile = lazy(() =>
  import("../pages/Templates/RealEstateProfile")
);
const EditUser = lazy(() =>
  import("../pages/ConfigurationPages/PersonalProfile")
);
const EditAppointment = lazy(() =>
  import("../pages/ConfigurationPages/AppointmentProfile")
);
const EditRestaurant = lazy(() =>
  import("../pages/ConfigurationPages/RestaurantProfile")
);
const EditShop = lazy(() => import("../pages/ConfigurationPages/ShopProfile"));
const EditRealEstate = lazy(() =>
  import("../pages/ConfigurationPages/RealEstateProfile")
);
const TemplateSelection = lazy(() =>
  import("../pages/LogRig/TemplateSelection")
);

function UserProfileConfigLogin() {
  const navigateTo = useNavigate();
  const location = useLocation();
  const [isAccount, setIsAccount] = useState(false);
  const [componentToRender, setComponentToRender] = useState(null);
  const [userData, setUserData] = useState(null);
  const { path } = useParams();
  const [token, setToken] = useState(null);
  function setCookieExpires(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/; secure; samesite=strict`;
  }
  useEffect(() => {
    const accessToken = getCookie("landingpageAccessToken");
    setToken(accessToken);

    fetchRouting(path, accessToken)
      .then((data) => {
        setUserData(data);
        const isConfig = data.config;
        const templateType = data.template_type;
        setIsAccount(data.account);
        const componentMap = {
          6745: isConfig ? EditAppointment : AppointmentProfile,
          9217: isConfig ? EditRestaurant : RestaurantProfile,
          5147: isConfig ? EditShop : ShopProfile,
          1897: isConfig ? EditRealEstate : RealEstateProfile,
          7895: isConfig ? EditUser : UserProfile,
          1047: TemplateSelection,
        };
        const Component = componentMap[templateType];
        if (Component) {
          setComponentToRender(() => Component);
        } else {
          window.location.href = "/";
        }
      })
      .catch((error) => {
        navigateTo("/login");
        console.error("Failed to fetch user data", error);
      });
  }, [path]);

  const handleTemplateSelection = (template) => {
    const componentMap = {
      6745: EditAppointment,
      9217: EditRestaurant,
      5147: EditShop,
      1897: EditRealEstate,
      7895: EditUser,
      1047: TemplateSelection,
    };

    const Component = componentMap[template];
    if (Component) {
      setComponentToRender(() => Component);
    } else {
      window.location.href = "/";
    }
  };

  return (
    <div>
      {userData && componentToRender && (
        <Suspense fallback={<div></div>}>
          {React.createElement(componentToRender, {
            path,
            token,
            isAccount,
            handleTemplateSelection,
          })}
        </Suspense>
      )}
    </div>
  );
}

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

async function fetchRouting(path, token, navigateTo) {
  const response = await axios.post("/api/post-template-route", {
    path,
    token,
  });
  if (response.status !== 200) {
    navigateTo("/login");
    throw new Error("Failed to fetch");
  }
  return response.data;
}

export default UserProfileConfigLogin;
